/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export { Centered } from '../common.style';

export const OptInButtonContainer = styled.div({
  marginTop: `${gridSize() * 3}px`,
  /* spinner on a primary button */
  circle: {
    stroke: token('color.border.inverse'),
  },
});
